import { useState, useEffect, useMemo } from "react";

import { useMutation, useQuery, useQueryClient } from "react-query";
import { Auth } from "shared/@auth/Auth";
import { useLocation } from "react-router-dom";

export function useDecisionsQueries() {
  const { makeAuthedRequest } = Auth.useContainer();
  const location = useLocation();

  const { data: pastDecisionData, status: statusPastDecision } = useQuery(
    ["decisions"],
    () =>
      makeAuthedRequest(
        `/management-team/decisions/${
          location.pathname.includes("management-team") ? "MT" : "EC"
        }/past`
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      })
  );

  const { pastDecisions: data } = useMemo(() => {
    if (pastDecisionData == null) {
      return { pastDecisions: [] };
    } else {
      return { pastDecisions: pastDecisionData };
    }
  }, [pastDecisionData]);

  return { pastDecisions: data, statusPastDecision };
}

export function useDecisionsMutations() {
  const { makeAuthedRequest } = Auth.useContainer();

  const displayResultsPut = useMutation(["display"], async (displayObject) =>
    makeAuthedRequest(`/management-team/decision/display-results`, {
      method: "PUT",
      body: JSON.stringify(displayObject),
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const votingStatusPut = useMutation(
    ["voting-status"],
    async (displayObject) =>
      makeAuthedRequest(`/management-team/decision/voting`, {
        method: "PUT",
        body: JSON.stringify(displayObject),
      }).then(async (res) => {
        if (res.ok) {
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      })
  );

  const votingProxyPut = useMutation(["voting-proxy"], async (displayObject) =>
    makeAuthedRequest(`/management-team/decision/proxy-vote`, {
      method: "PUT",
      body: JSON.stringify(displayObject),
    }).then(async (res) => {
      if (res.ok) {
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return { displayResultsPut, votingStatusPut, votingProxyPut };
}

export function useDecisions() {
  const q = useDecisionsQueries();
  const m = useDecisionsMutations();
  return { ...q, ...m };
}
